import { FC } from "react";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useDispatch } from "react-redux";
import * as auth from '../../../app/modules/auth/redux/AuthRedux'
const Loading: FC<LoadingProps> = (props) => {
    return <>{props.open &&
        (
            <div className="loading-sdx">
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 99999999 , }}
                    open={props.open}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
        )}
    </>
}
export const showLoading = (open: boolean, dispatch: any) => {
    dispatch(auth.actions.openLoading(open))
}
interface LoadingProps {
    open: boolean,
    showLoading?(): void
}
export { Loading }